import { useEffect, useRef } from 'react'

interface AlertHistory { id: number }

interface Asset {
  id?: number
  alert_state_histories?: AlertHistory[]
}

/**
 * Refetches asset details when the alert history list changes.
 * Triggers a single refetch when either the length of the history array
 * increases or the id of the last entry changes.
 */
export default function useAlertHistoryRefetch(
  asset: Asset,
  refetch: () => void,
) : void {
  const historyLength = asset.alert_state_histories?.length || 0
  const lastHistoryId = asset.alert_state_histories?.[historyLength - 1]?.id ?? null

  const lastValues = useRef({ id: asset.id, length: historyLength, lastId: lastHistoryId })

  useEffect(() => {
    if (!asset?.id) return

    const { id: prevId, length: prevLen, lastId: prevLast } = lastValues.current
    if (prevId === asset.id && prevLen === historyLength && prevLast === lastHistoryId) {
      return
    }

    lastValues.current = { id: asset.id, length: historyLength, lastId: lastHistoryId }
    refetch()
  }, [asset.id, historyLength, lastHistoryId, refetch])
}
